import { RootState } from '../Application';
import { isConfigReady } from '../domain/Config/Conditions';
import { hasActiveSport } from '../domain/Order/Conditions';
import { app } from '../initApp';
import { Condition } from '../screen/Condition';
import { UseCase } from './usecase/UseCase';

export const showGrayGoodsStepUseCase:UseCase = {
  type: 'SHOW_GRAY_GOODS_STEP',

  checkConditions: ( state: RootState ) => {
    return Condition.evaluate(state, [isConfigReady, hasActiveSport]);
  },

  run: () => {
    // @ts-ignore
    return Cx.resolve();
  }
};

export function canShowGrayGoodsStep(state: RootState) {
  return showGrayGoodsStepUseCase.checkConditions( state ).isAllowed;
}

export function showGrayGoodsStep(){
  app.runUseCase(showGrayGoodsStepUseCase);
}
